import React from 'react';
import { get, isEmpty } from 'lodash';
import { formattedAddress, isRestaurantAvailable } from '../../../lib/helper';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../translations/lang/en-US.json';
import { connect } from 'react-redux';
import { getRestaurantHours } from '../../dashboard/reducer';

class DescribeRestaurant extends React.Component {
  isActive = mode => {
    return (
      this.props.activeRestaurantLocation.id === this.props.data.id &&
      Number(this.props.modeOfOrder) === mode
    );
  };

  render() {
    const { restaurantHours } = this.props;
    const isRestaurantOpenNow = isRestaurantAvailable(restaurantHours);
    let diningOptions = get(this, 'props.data.diningOption', '');
    diningOptions = diningOptions !== null ? diningOptions.toLowerCase() : '';
    return (
      <div
        className={
          this.props.isOne === 1
            ? 'no-border restaurant-description'
            : 'restaurant-description'
        }
      >
        <div className="restaurant-title">
          <b> {this.props.data.title} </b>
        </div>
        <div className="restaurant-content">
          {formattedAddress(this.props.data)}
        </div>
        <div className="order-type-actions">
          {this.props.data.diningOption === '0' ||
          isEmpty(this.props.data.diningOption) ? (
            <span className="label-red">
              <FormattedMessage
                id="restaurantNotServingAnyOrders"
                defaultMessage={defaultMsg.restaurantNotServingAnyOrders}
              />
            </span>
          ) : (
            <span>
              {diningOptions.includes('pickup') ? (
                <button
                  onClick={e => this.props.handleOrderType(this.props.data, 1)}
                  className={`btn customButton ${
                    this.isActive(1) ? 'active' : ''
                  }`}
                >
                  <FormattedMessage
                    id="pickup"
                    defaultMessage={defaultMsg.pickup}
                  />
                </button>
              ) : null}
              {diningOptions.includes('deliver') ? (
                <button
                  onClick={e => this.props.handleOrderType(this.props.data, 2)}
                  className={`btn customButton ${
                    this.isActive(2) ? 'active' : ''
                  }`}
                  disabled={!isRestaurantOpenNow}
                >
                  <FormattedMessage
                    id="delivery"
                    defaultMessage={defaultMsg.delivery}
                  />
                </button>
              ) : null}
              {diningOptions.includes('dine-in') ? (
                <button
                  onClick={e => this.props.handleOrderType(this.props.data, 3)}
                  className={`btn customButton ${
                    this.isActive(3) ? 'active' : ''
                  }`}
                >
                  <FormattedMessage
                    id="dineIn"
                    defaultMessage={defaultMsg.dineIn}
                  />
                </button>
              ) : null}
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  restaurantHours: getRestaurantHours(state),
}))(DescribeRestaurant);



// WEBPACK FOOTER //
// ./src/views/orderType/components/DescribeRestaurant.jsx